
import { Vue, Options, prop } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";
import { AccountController } from "../../controllers/AccountController";
import { BalanceController } from "../../controllers/BalanceController";
import formatPrice from "@/app/infrastructures/misc/common-library/v2/FormatPrice";
import { IS_SENDER_ACCOUNT } from "@/app/infrastructures/misc/Constants";
import { GTMCommonEvent } from "@/app/infrastructures/misc/gtm-event/common-event";
import { FlagsPermissionSaldo } from "@/feature-flags/flags-permission-saldo";

class Props {
  collapse = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  components: {
    OverlayPanel
  }
})
export default class CardSisaSaldo extends Vue.with(Props) {
  get visibleSaldo() {
    return FlagsPermissionSaldo.permission_saldo_enable.isEnabled();
  }
  // methods
  openTooltip(event: Event) {
    (this.$refs as any)?.opSisaSaldo?.toggle(event);
  }

  hideTooltip() {
    (this.$refs as any)?.opSisaSaldo?.hide();
  }

  get balanceColor(): string {
    const wallet = Number(this.balanceData.walletBalance);
    const min = Number(this.accountData.limit_rule_min_balance);
    const border = Number(this.accountData.limit_rule_limit_border);

    if (wallet < min) {
      return "bg-red-lp-750"; // saldo di bawah minimum
    }

    if (wallet >= min && wallet <= min + border) {
      return "bg-yellow-lp-1300"; // saldo dekat batas aman
    }

    if (wallet > min + border) {
      return "bg-blue-lp-100"; // saldo aman
    }

    return "";
  }

  get shouldShowSaldoWarning(): boolean {
    if (
      this.accountData.account_type_detail === null || 
      this.isSenderAccount
    ) {
      return false;
    }

    const wallet = Number(this.balanceData.walletBalance);
    const min = Number(this.accountData.limit_rule_min_balance);
    const border = Number(this.accountData.limit_rule_limit_border);

    return wallet <= min + border;
  }

  get accountData() {
    return AccountController.accountData;
  }

  get accountIsForeign() {
    return AccountController.accountData.accountIsForeign;
  }

  get accountCurrency() {
    return AccountController.accountData.accountCurrency;
  }

  get priceView() {
    return formatPrice(
      BalanceController.balanceData.walletBalance,
      "",
      this.accountCurrency as "IDR" | "MYR",
      AccountController.accountData.accountCurrencySymbol
    );
  }

  get isLoadingBalance() {
    return BalanceController.isLoadingBalance;
  }

  get balanceData() {
    return BalanceController.balanceData;
  }

  isSenderAccount = IS_SENDER_ACCOUNT;

  get saldoWarning() {
    const balance = this.balanceData.walletBalance;
    const min = this.accountData.limit_rule_min_balance;
    const border = this.accountData.limit_rule_limit_border;

    if (balance <= min + border && balance >= min) {
      return this.$t("Saldo Anda mendekati limit");
    }
    if (balance < min) {
      return this.$t("Saldo Anda dibawah limit");
    }
    return this.$t("Saldo Anda mencapai limit");
  }

  isHideBalanceDetail = false;
  gotoBalance() {
    this.$emit("click");
    this.$router.push("/balance");
    if (IS_SENDER_ACCOUNT) GTMCommonEvent("sender_saldo");
  }
}
